import scenarioImages from '../scenarioImages'

export default {
  slug: 'im21',
  title: 'IM21',
  i18nKey: 'AutomotiveImuProducts.im21',
  heroTitleSize: 'large',
  images: {
    hero: require('@/assets/images/pixso-automotive-detail/im21-hero.png'),
    description: require('@/assets/images/pixso-automotive-detail/im21-description.png'),
    feature: require('@/assets/images/pixso-automotive-detail/im21-feature.png')
  },
  descriptionTags: [
    { key: 'arrayIMU', image: require('@/assets/images/pixso-automotive-detail/icon-arrayimu.svg') },
    { key: 'accelerometer', image: require('@/assets/images/pixso-automotive-detail/icon-accelerometer.svg') },
    { key: 'gyroscope', image: require('@/assets/images/pixso-automotive-detail/icon-gyro.svg') }
  ],
  featureTags: [
    { key: 'lowPower', image: require('@/assets/images/pixso-automotive-detail/icon-low-power.svg') },
    { key: 'compact', image: require('@/assets/images/pixso-automotive-detail/icon-compact.svg') },
    { key: 'autoAssembly', image: require('@/assets/images/pixso-automotive-detail/icon-autoassembly.png') },
    { key: 'fullTemperature', image: require('@/assets/images/pixso-automotive-detail/icon-calibration.svg') }
  ],
  scenarios: [
    {
      key: 'tunnelFork',
      image: scenarioImages.tunnelFork
    },
    {
      key: 'parking',
      image: scenarioImages.parking
    },
    {
      key: 'overpass',
      image: scenarioImages.overpass
    },
    {
      key: 'urbanCanyon',
      image: scenarioImages.urbanCanyon
    },
    {
      key: 'complexTraffic',
      image: scenarioImages.complexTraffic
    },
    {
      key: 'treeLinedStreet',
      image: scenarioImages.treeLinedStreet
    }
  ],
  specTabs: [
    {
      labelKey: 'ProductSpecs.tabs.gyro',
      rows: [
        { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.gyro.range' } },
        { labelKey: 'ProductSpecs.rows.零偏稳定性', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.gyro.biasStability' } },
        { labelKey: 'ProductSpecs.rows.零偏不稳定性', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.gyro.biasInstability' } },
        { labelKey: 'ProductSpecs.rows.全温零偏', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.gyro.fullTempBias' } },
        { labelKey: 'ProductSpecs.rows.标度误差', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.gyro.scaleError' } },
        { labelKey: 'ProductSpecs.rows.角度随机游走', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.gyro.angleRandomWalk' } },
        { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.gyro.operatingFrequency' } }
      ]
    },
    {
      labelKey: 'ProductSpecs.tabs.accelerometer',
      rows: [
        { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.accelerometer.range' } },
        { labelKey: 'ProductSpecs.rows.零偏稳定性', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.accelerometer.biasStability' } },
        { labelKey: 'ProductSpecs.rows.零偏不稳定性', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.accelerometer.biasInstability' } },
        { labelKey: 'ProductSpecs.rows.全温零偏', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.accelerometer.fullTempBias' } },
        { labelKey: 'ProductSpecs.rows.标度误差', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.accelerometer.scaleError' } },
        { labelKey: 'ProductSpecs.rows.速度随机游走', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.accelerometer.velocityRandomWalk' } },
        { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.accelerometer.operatingFrequency' } }
      ]
    },
    {
      labelKey: 'ProductSpecs.tabs.physicalAndElectrical',
      rows: [
        { labelKey: 'ProductSpecs.rows.尺寸', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.physical.dimensions' } },
        { labelKey: 'ProductSpecs.rows.重量', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.physical.weight' } },
        { labelKey: 'ProductSpecs.rows.连接器型号', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.physical.connectorModel' } },
        { labelKey: 'ProductSpecs.rows.通讯接口', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.physical.communicationInterface' } },
        { labelKey: 'ProductSpecs.rows.供电电压', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.physical.supplyVoltage' } },
        { labelKey: 'ProductSpecs.rows.功耗', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.physical.powerConsumption' } }
      ]
    },
    {
      labelKey: 'ProductSpecs.tabs.environmentParams',
      rows: [
        { labelKey: 'ProductSpecs.rows.工作温度', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.environment.operatingTemperature' } },
        { labelKey: 'ProductSpecs.rows.存储温度', value: { valueKey: 'AutomotiveImuProducts.im21.specValues.environment.storageTemperature' } }
      ]
    }
  ]
}
